import { V2_COUNTRY_MAPPER } from 'globals/constants/address';
import {
  InternationalAddress,
  UnitedStatesAddress,
  BillingAddress,
} from 'types';

export const formatBillingAddress = (billingAddress?: BillingAddress) => {
  if (!billingAddress) return '';
  let formattedAddress = '';
  if (billingAddress.email) {
    formattedAddress += `${billingAddress.email}\n`;
  }

  const { address } = billingAddress;

  if (address) {
    const stateOrPrincipalRegion =
      address.country === 'United_States'
        ? (address as UnitedStatesAddress).state
        : (address as InternationalAddress).principalRegion;

    formattedAddress += `${address.streetAddress1}`;
    if (address.streetAddress2) {
      formattedAddress += ` ${address.streetAddress2}`;
    }
    formattedAddress += `\n${address.city}, ${stateOrPrincipalRegion} ${address.zipCode}\n`;

    formattedAddress += `${V2_COUNTRY_MAPPER[address.country as keyof typeof V2_COUNTRY_MAPPER]}\n`;
  }

  return formattedAddress;
};
